import useProductRatingActions from './useProductRatingActions'

export default useProductRatingActions
